import { Pipe, PipeTransform } from '@angular/core';
import { Agent, AgentKeys } from '@ag-common-lib/public-api';

@Pipe({ name: 'agentMainInfoPrimaryEmail' })
export class AgentMainInfoPrimaryEmailPipe implements PipeTransform {
  transform(agentData: Agent): string {
    return agentData[AgentKeys.p_email] ?? '';
  }
}
